import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Repeat } from "lib/@components/repeat"
import { ScheduleWeeks } from "routes/plan/plugins/weekly-planner/plugins/planner-schedule-list/schedule-weeks"
import { PlannerDetails } from "routes/plan/planner-details"

PlannerDetails("schedules").plug(<PlannerScheduleList />)

function PlannerScheduleList() {
    const { allSchedules } = useBoundContext()
    return <Repeat list={allSchedules} item={<ScheduleWeeks />} />
}
